var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formattedDate))]),_c('strong',[_c('br'),_vm._v(_vm._s(_vm.formattedTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }